import { combineReducers } from 'redux'
import { aiDashboardModuleReducer, aiDashboardModuleSagas } from './Dashboard'

export const aiModulesReducer = combineReducers({
  dashboard: aiDashboardModuleReducer
})

export const aiModulesSagas = [...aiDashboardModuleSagas]
